'use client'
import { FormEvoConfigurationModule } from '@repo/formevo-configuration/FormEvoConfigurationModule'

const FormEvoConfiguration = () => {
  return <FormEvoConfigurationModule />
}

export default FormEvoConfiguration
